module.exports = __webpack_public_path__ + "static/frontUserNew/img/typedocument.87bc00a0.svg";